import { useTranslation } from "react-i18next";
import { ScrollTop } from "primereact/scrolltop";
import DadosConsulta from "./DadosConsulta";
import EnderecoHist from "./EnderecoHist";
import HistoricoInfo from "./HistorioInfo";
import ListaConsulta from "./ListaConsulta";
import Empresas from "./Empresas";
import Acoes from "./Acoes";
import Score from "./Score";
import CCFS from "./CCFS";
import Apontamentos from "./Apontamentos";
import Cadastral from "./Cadastral";
import AcoesCompleta from "./AcoesCompleta";
import Informativo from "./Informativo";
import CompletaPF from "./CompletaPF";
import Pendencias from "./Pendencias";
import Protestos from "./Protestos";
import RendaPresumida from "./RendaPresumida";
import CompletaPJ from "./CompletaPJ";
import DadosConsultaPJ from "./DadosConsultaPJ";
import Socios from "./Socios";
import Aviso from "./Aviso";
import FaturamentoPresumido from "./FaturamentoPresumido";
import LimiteCreditoPJ from "./LimiteCreditoPJ";
import MaisNegocio from "./MaisNegocio";
import ScoreGrauAtvidadePJ from "./ScoreGrauAtividadePJ";
import ParticipacaoEmpresa from "./ParticipacaoEmpresa";
import ComportamentoFinanceiro from "./ComportamentoFinanceiro";
import LinhaCredito from "./LinhaCredito";
import Endividamento from "./Endividamento";
import PontualidadePagamento from "./PontualidadePagamento";
import HistoricoPagamento from "./HistoricoPagamento";
import ProtestoQuod from "./ProtestoQuod";
import IndicadorNegocio from "./IndicadorNegocio";
import HistoricoVencido from "./HistoricoVencido";
import GastoEstimadoPJ from "./GastoEstimadoPJ";
import ScoreInadimplenciaPJ from "./ScoreInadimplenciaPJ";
import AnaliseSetorial from "./AnaliseSetorial/AnaliseSetorial";
import { Gps895Page } from "./Gps895";
import { Gps894Page } from "./Gps894";
import { Gps391 } from "./Gps391";
import { Gps353 } from "./Gps353";
import { ProtestoCenprot } from "./ProtestoCenprot";
import { BacenScoreSCRPage } from "./BacenScoreSCR";
import GPS from "./GPS";
import PassagensComerciais from "./PassagensComerciais";
import CreditoScore from "./CreditoScore";
import PendenciaCompany from "./PedenciaCompany";
import { InstituicaoPagamento } from "./InstituicaoPagamento";
import { InstituicaoPagamentoSintetico } from "./InstituicaoPagamentoSintetico";
import PendenciaMercado from "./PendenciaMercado";
import { CadastralEmpresa } from "./CadastralEmpresa";
import PessoaRFDocumento from "./PessoaRFDocumento";
import PessoaAssistenteSocial from "./PessoaAssistenteSocial";
import AcoesCompletaMensagem from "./AcoesCompletaMensagem";
import { CadastralVNome } from "./CadastralVNome";
import { CadastralV } from "./CadastralV";
import CadastralLocalizaTelefone from "./CadastralLocalizaTelefone";
import { ConsultaSCRPage } from "./ConsultaSCR/ConsultaSCR";
import ProtestoCartorio from "./ProtestoCartorio";
import SollosScpcProtestoNacional from "./SollosScpcProtestoNacional";
import RelatorioBasico from "./RelatorioBasico";
import ResumoRestricoes from "./ResumoRestricoes";



export default function RespostaInsumoPage({
  resposta,
}: {
  resposta: any;
}) {

  const { t } = useTranslation();

  const opcoesPai: string[] = resposta.informativo?.opcoesPai ?? [];

  const EXCLUDED_OPCOES = [
    "CONSULTA RH",
    "FONE LOCALIZA",
    "ENDIVIDAMENTO FUTURO",
    "Cadastral + Comportamental",
    "COMPORTAMENTAL PJ AVULSA",
    "CADASTRO PF",
    "ENDIVIDAMENTO FUTURO PJ",
    "ENDIVIDAMENTO FUTURO PF",
    "CARTORIO_PROTESTO_REGIONAL",
    "CADASTRAL PREMIUM",
    "Cenprot Oficial",
    "CADASTRO PJ",
    "CADASTRAL BÁSICA PJ",
    "BENEFICIO_SOCIAL",
  ];

  // Relatório Básico não consulta Quod; o backend pode devolver listas vazias que virariam "Nada Consta"
  const isRelatorioBasico = !!(resposta.relatorioBasicoPF || resposta.relatorioBasicoPJ
    || resposta.relatorioBasicoPFCustom || resposta.relatorioBasicoPJCustom);

  const isExcluded = isRelatorioBasico || EXCLUDED_OPCOES.some((excl) =>
    opcoesPai.some((o) => o.trim() === excl)
  );

  // Consultas que exibem Ações e Protestos SP mesmo junto do Relatório Básico (sem retorno mostra Nada Consta)
  const OPCOES_COM_ACOES_PROTESTOS = ["TOP PJ ONZE SOLUÇÕES PREMIUM"];

  const exibirAcoesProtestos = !isExcluded || opcoesPai.some((o) =>
    OPCOES_COM_ACOES_PROTESTOS.includes(o?.trim().toUpperCase())
  );

  // Nas consultas TOP, Passagens Comerciais é exibida por último
  const OPCOES_PASSAGENS_AO_FINAL = ["TOP PF", "TOP PJ"];

  const passagensAoFinal = opcoesPai.some((o) =>
    OPCOES_PASSAGENS_AO_FINAL.includes(o?.trim().toUpperCase())
  );


  return (
    <>

      <br></br>
      <br></br>
      <Informativo informativo={resposta.informativo}></Informativo>
      <br></br>
      {resposta.avisos.length > 0 && (
        <Aviso avisos={resposta.avisos}></Aviso>)}
      <br></br>
      {resposta.dadosConsulta && (
        <DadosConsulta dadosConsulta={resposta.dadosConsulta}></DadosConsulta>)}
      {resposta.dadosConsultaPJ && (
        <DadosConsultaPJ capitalSocial={resposta.capitalSocial} dadosConsultaPJ={resposta.dadosConsultaPJ}></DadosConsultaPJ>
      )}
      {resposta.cadastralEmpresaCnpj && (
        <CadastralEmpresa
          cadastralEmpresaCnpj={resposta.cadastralEmpresaCnpj}
        ></CadastralEmpresa>
      )}
      {resposta.pessoaRFDocumento && (
        <>
          <br></br>
          <PessoaRFDocumento data={resposta.pessoaRFDocumento} />
        </>
      )}
      {resposta.pessoa && (
        <> <br></br><Cadastral pessoa={resposta.pessoa}></Cadastral></>

      )}
      {resposta.cadastralVNome && (
        <CadastralVNome
          cadastralVNome={resposta.cadastralVNome}
        ></CadastralVNome>
      )}

      {resposta.cadastralV && (
        <CadastralV
          cadastralV={resposta.cadastralV}
        ></CadastralV>
      )}
      {resposta.cadastralLocalizaTelefone && (
        <CadastralLocalizaTelefone
          cadastralLocalizaTelefone={resposta.cadastralLocalizaTelefone}
        ></CadastralLocalizaTelefone>
      )}
      {resposta.completaPF && (
        <CompletaPF completaPF={resposta.completaPF}></CompletaPF>
      )}
      {resposta.completaPJ && (
        <CompletaPJ completaPJ={resposta.completaPJ}></CompletaPJ>
      )}
      {resposta.pessoaAssistenteSocial && (
        <>
          <br></br>
          <PessoaAssistenteSocial pessoaAssistenteSocial={resposta.pessoaAssistenteSocial} />
        </>
      )}
      {resposta.conglomerados && resposta.conglomerados.length > 0 && (
        <>
          <br></br>
          <HistoricoInfo showHist={false} label={t('conglomerados')} historicos={resposta.conglomerados} ></HistoricoInfo>
        </>
      )}
      {resposta.enderecosHist && resposta.enderecosHist.length > 0 && (
        <>
          <br></br>
          <EnderecoHist enderecos={resposta.enderecosHist} ></EnderecoHist>
        </>
      )}
      {resposta.emailsHist && resposta.emailsHist.length > 0 && (
        <>
          <br></br>
          <HistoricoInfo showHist={true} label={t('email')} historicos={resposta.emailsHist} ></HistoricoInfo>
        </>
      )}

      {resposta.calularesHist && resposta.calularesHist.length > 0 && (
        <>
          <br></br>
          <HistoricoInfo showHist={true} label={t('celular')} historicos={resposta.calularesHist} ></HistoricoInfo>
        </>
      )}
      {resposta.telefonesHist && resposta.telefonesHist.length > 0 && (
        <>
          <br></br>
          <HistoricoInfo showHist={true} label={t('fone')} historicos={resposta.telefonesHist} ></HistoricoInfo>
        </>
      )}
      {resposta.socios && resposta.socios.length > 0 && (
        <>
          <br></br>
          <Socios showRestricao={resposta.showApontamento} socios={resposta.socios} ></Socios>
        </>
      )}
      {resposta.participacoesEmpresa && resposta.participacoesEmpresa.length > 0 && (
        <>
          <br></br>
          <ParticipacaoEmpresa showRestricao={resposta.showApontamento} participacoes={resposta.participacoesEmpresa} ></ParticipacaoEmpresa>
        </>
      )}
      {resposta.score && (
        <>
          <br></br>
          <Score scoreBoleto={false} label="Score" score={resposta.score} ></Score>
        </>
      )}
      {resposta.scoreBoletoPJ && (
        <>
          <br></br>
          <Score scoreBoleto={true} label="Score Boleto PJ" score={resposta.scoreBoletoPJ} ></Score>
        </>
      )}
      {resposta.limiteCreditoPJ && (
        <>
          <br></br>
          <LimiteCreditoPJ limiteCreditoPJ={resposta.limiteCreditoPJ} ></LimiteCreditoPJ>
        </>
      )}
      {resposta.scoreInadimplenciaPJ && (
        <>
          <br></br>
          <ScoreInadimplenciaPJ
            scoreInadimplenciaPJ={resposta.scoreInadimplenciaPJ}
          ></ScoreInadimplenciaPJ>
        </>
      )}
      {resposta.scoreGrauAtividadePJ && (
        <>
          <br></br>
          <ScoreGrauAtvidadePJ scoreGrauAtividadePJ={resposta.scoreGrauAtividadePJ} ></ScoreGrauAtvidadePJ>
        </>
      )}
      {resposta.faturamentosPresumido && (
        <>
          <br></br>
          <FaturamentoPresumido faturamentos={resposta.faturamentosPresumido} ></FaturamentoPresumido>
        </>
      )}
      {resposta.maisNegocio && (
        <>
          <br></br>
          <MaisNegocio maisNegocio={resposta.maisNegocio} ></MaisNegocio>
        </>
      )}
      {resposta.gastoEstimadoPJ && (
        <>
          <br></br>
          <GastoEstimadoPJ
            gastoEstimadoPJ={resposta.gastoEstimadoPJ}
          ></GastoEstimadoPJ>
        </>
      )}
      {resposta.comportamentoFinanceiro && (
        <>
          <br></br>
          <ComportamentoFinanceiro comportamento={resposta.comportamentoFinanceiro} ></ComportamentoFinanceiro>
        </>
      )}
      {resposta.linhaCredito && (
        <>
          <br></br>
          <LinhaCredito linhaCredito={resposta.linhaCredito} ></LinhaCredito>
        </>
      )}
      {resposta.endividamentos && resposta.endividamentos.length > 0 && (
        <>
          <br></br>
          <Endividamento endividamentos={resposta.endividamentos} ></Endividamento>
        </>
      )}
      {resposta.pontualidadePagamento && (
        <>
          <br></br>
          <PontualidadePagamento pontualidadePagamento={resposta.pontualidadePagamento} ></PontualidadePagamento>
        </>
      )}
      {resposta.historicoPagamento && (
        <>
          <br></br>
          <HistoricoPagamento historicoPagamento={resposta.historicoPagamento} ></HistoricoPagamento>
        </>
      )}
      {resposta.historicoVencido && (
        <>
          <br></br>
          <HistoricoVencido
            historicoVencido={resposta.historicoVencido}
          ></HistoricoVencido>
        </>
      )}
      {resposta.rendaPresumida && (
        <>
          <br></br>
          <RendaPresumida rendaPresumida={resposta.rendaPresumida} ></RendaPresumida>
        </>
      )}
      {resposta.analises && resposta.analises.length > 0 && (
        <>
          <br></br>
          <AnaliseSetorial analises={resposta.analises} ></AnaliseSetorial>
        </>
      )}


      {resposta.empresas && resposta.empresas.length > 0 && (
        <>
          <br></br>
          <Empresas empresas={resposta.empresas} ></Empresas>
        </>
      )}


      {resposta.indicadores && resposta.indicadores.length > 0 && (
        <>
          <br></br>
          <IndicadorNegocio indicadores={resposta.indicadores}></IndicadorNegocio> </>)}
      {(resposta.showApontamento || (!isExcluded && (resposta.ccfs !== undefined || resposta.acoes !== undefined || resposta.protestosQuod !== undefined))) && (
        <>
          <br></br>
          <ResumoRestricoes
            apontamentos={resposta.showApontamento ? (resposta.apontamentos ?? []) : undefined}
            ccfs={!isExcluded ? resposta.ccfs : undefined}
            acoes={!isExcluded ? resposta.acoes : undefined}
            protestos={!isExcluded ? resposta.protestosQuod : undefined}
            consulta={resposta.consulta}
          />
        </>
      )}
      {resposta.showApontamento && (
        <>
          <br></br>
          <Apontamentos apontamentos={resposta.apontamentos} ></Apontamentos>
        </>
      )}
      {resposta.cadastralSrcBacenScorePositivo && (
        <>
          {" "}
          <br></br>
          <BacenScoreSCRPage {...resposta.cadastralSrcBacenScorePositivo} />
        </>
      )}
      {
        resposta.ccfs !== undefined && !isExcluded && (
          <>
            <br></br>
            <CCFS ccfs={resposta.ccfs} ></CCFS>
          </>
        )
      }
      {
        exibirAcoesProtestos && (
          <>
            <br></br>
            <Acoes acoes={resposta.acoes ?? []} ></Acoes>
          </>
        )
      }
      {
        exibirAcoesProtestos && (
          <>
            <br></br>
            <ProtestoQuod protestos={resposta.protestosQuod ?? []} ></ProtestoQuod>
          </>
        )
      }

      {
        resposta.protestoCentroProt && (
          <>
            <br></br>
            <ProtestoCenprot data={resposta.protestoCentroProt} ></ProtestoCenprot>
          </>
        )
      }
      {
        resposta.pendencia && (
          <>
            <br></br>
            <Pendencias pendencia={resposta.pendencia} ></Pendencias>
          </>
        )
      }
      {
        resposta.gps353 && (
          <>
            {" "}
            <br></br>
            <Gps353 {...resposta.gps353} />
          </>
        )
      }
      {resposta.protestoCartorio && (
        <>
          <br></br>
          <ProtestoCartorio data={resposta.protestoCartorio}></ProtestoCartorio>
        </>
      )}
      {resposta.protestoCartorioRegional && (
        <>
          <br></br>
          <ProtestoCartorio data={resposta.protestoCartorioRegional}></ProtestoCartorio>
        </>
      )}
      {resposta.sollosScpcProtestoNacional && (
        <>
          <br></br>
          <SollosScpcProtestoNacional sollosScpcProtestoNacional={resposta.sollosScpcProtestoNacional} />
        </>
      )}
      {resposta.relatorioBasicoPF && (
        <>
          <br></br>
          <RelatorioBasico data={resposta.relatorioBasicoPF} titulo="Relatório Básico PF"></RelatorioBasico>
        </>
      )}
      {resposta.relatorioBasicoPJ && (
        <>
          <br></br>
          <RelatorioBasico data={resposta.relatorioBasicoPJ} titulo="Relatório Básico PJ"></RelatorioBasico>
        </>
      )}
      {resposta.relatorioBasicoPFCustom && (
        <>
          <br></br>
          <RelatorioBasico data={resposta.relatorioBasicoPFCustom} titulo="Pendencias De Mercado" pj={false}></RelatorioBasico>
        </>
      )}
      {resposta.relatorioBasicoPJCustom && (
        <>
          <br></br>
          <RelatorioBasico data={resposta.relatorioBasicoPJCustom} titulo="Pendencias De Mercado" pj={true}></RelatorioBasico>
        </>
      )}
      {
        resposta.gps391 && (
          <>
            {" "}
            <br></br>
            <Gps391 data={resposta.gps391} />
          </>
        )
      }
      {
        resposta.gps894 && Object.getOwnPropertyNames(resposta.gps894).length > 0 && (
          <>
            {" "}
            <br></br>
            <Gps894Page {...resposta.gps894} />
          </>
        )
      }

      {
        resposta.gps895 && Object.getOwnPropertyNames(resposta.gps895).length > 0 && (
          <>
            {" "}
            <br></br>
            <Gps895Page {...resposta.gps895} />
          </>
        )
      }
      {
        resposta.acoesCompleta && resposta.acoesCompleta.length > 0 && (
          <>
            <br></br>
            <AcoesCompleta acoes={resposta.acoesCompleta} ></AcoesCompleta>
          </>
        )
      }

      {
        resposta.acoesCompletaMensagem && (
          <>
            <br></br>
            <AcoesCompletaMensagem mensagem={resposta.acoesCompletaMensagem}></AcoesCompletaMensagem>
          </>
        )
      }

      {
        resposta.gps && (
          <>
            {" "}
            <br></br>
            <GPS gps={resposta.gps} ocultarPassagens={passagensAoFinal} />
          </>
        )
      }
      {
        resposta.showProtesto && (
          <>
            <br></br>
            <Protestos cartorios={resposta.cartorios} ></Protestos>
          </>
        )
      }
      {
        resposta.creditoScore && (
          <>
            <br></br>
            <CreditoScore creditoScore={resposta.creditoScore} ></CreditoScore>
          </>
        )
      }
      {
        resposta.pendenciaCompany && (
          <>
            <br></br>
            <PendenciaCompany
              pendenciaCompany={resposta.pendenciaCompany}
            ></PendenciaCompany>
          </>
        )
      }
      {
        resposta.instituicaoPagamento && (
          <>
            {" "}
            <br></br>
            <InstituicaoPagamento {...resposta.instituicaoPagamento} />
          </>
        )
      }
      {
        resposta.instituicaoPagamentoSintetico && (
          <>
            {" "}
            <br></br>
            <InstituicaoPagamentoSintetico {...resposta.instituicaoPagamentoSintetico} />
          </>
        )
      }
      {
        resposta.pendenciaMercado && (
          <>
            {" "}
            <br></br>
            <PendenciaMercado pendenciaMercado={resposta.pendenciaMercado} />
          </>
        )
      }
      {
        resposta.srcBacenScorePositivo && (
          <>
            {" "}
            <br></br>
            <BacenScoreSCRPage {...resposta.srcBacenScorePositivo} />
          </>
        )
      }
      {
        resposta.scrSeletor && (
          <>
            {" "}
            <br></br>
            <ConsultaSCRPage {...resposta} />
          </>
        )
      }
      {
        resposta.consulta && (
          <>
            <br></br>
            <ListaConsulta consulta={resposta.consulta} ></ListaConsulta>
          </>
        )
      }
      {
        passagensAoFinal && resposta.gps && !resposta.gps.mensagemErro && (
          <>
            <br></br>
            <PassagensComerciais passagens={resposta.gps.PASSAGENS_COMERCIAIS} />
          </>
        )
      }

      <br></br>
      <br></br>

      <ScrollTop
        style={{ marginBottom: "5rem" }}
        className="border-round bg-primary"
        icon="pi pi-arrow-up text-base"
      />
    </>
  );
}
